$(document).ready(function () {
  var $first = $('section.clFaq .accordian').first();
  $first.find('.accDetail').show();
  $first.find('h2').addClass('active');

  $('section.clFaq .accordian h2').click(function () {
    var $this = $(this);
    var $accDetail = $this.siblings('.accDetail');

    $('section.clFaq .accordian .accDetail').not($accDetail).slideUp();
    $('section.clFaq .accordian h2').not($this).removeClass('active');

    $accDetail.slideToggle();
    $this.toggleClass('active');
  });
});

// // Mobile Tabs

$(document).ready(function() {
  function handleTabClick() {
    if ($(window).width() <= 991) {
      $('section.clFaq .tabsBox a.tabBox:first-child').on('click', function(e) {
        e.preventDefault();
        $('section.clFaq .popupBox').addClass('active');
      });
    }
  }
  handleTabClick();
  $(window).resize(function() {
    $('section.clFaq .popupBox').removeClass('active');
    handleTabClick();
  });
  $('section.clFaq .popupBox .popupBoxHeader button.closePopup').on('click', function() {
    $('section.clFaq .popupBox').removeClass('active');
  });
});

// $(document).ready(function() {
//   function reorderActiveTab() {
//     if ($(window).width() <= 991) {
//       var $tabsBox = $('section.clFaq .tabsBox')
//       var $activeTab = $tabsBox.find('a.tabBox.active').first()
//       if ($activeTab.length) $tabsBox.prepend($activeTab)
//     }
//   }

//   function handleTabClick() {
//     if ($(window).width() <= 991) {
//       $('section.clFaq .tabsBox a.tabBox:first-child').off('click').on('click', function(e) {
//         e.preventDefault()
//         $('section.clFaq .popupBox').addClass('active')
//       })
//     }
//   }

//   reorderActiveTab()
//   handleTabClick()

//   $(window).resize(function() {
//     $('section.clFaq .popupBox').removeClass('active')
//     reorderActiveTab()
//     handleTabClick()
//   })

//   $('section.clFaq .popupBox .popupBoxHeader button.closePopup').on('click', function() {
//     $('section.clFaq .popupBox').removeClass('active')
//   })
// })
$(document).ready(function(){
  function reorderActiveTab(){
    if($(window).width()<=991){
      var $tabsBox=$('section.clFaq .tabsBox')
      var $activeTab=$tabsBox.find('a.tabBox.active').first()
      if($activeTab.length)$tabsBox.prepend($activeTab)
    }
  }
  function handleTabClick(){
    if($(window).width()<=991){
      $('section.clFaq .tabsBox a.tabBox:first-child').off('click').on('click',function(e){
        e.preventDefault()
        $('section.clFaq .popupBox').addClass('active')
        $('body').css('overflow','hidden')
      })
    }
  }
  reorderActiveTab()
  handleTabClick()
  $(window).resize(function(){
    $('section.clFaq .popupBox').removeClass('active')
    $('body').css('overflow','')
    reorderActiveTab()
    handleTabClick()
  })
  $('section.clFaq .popupBox .popupBoxHeader button.closePopup').on('click',function(){
    $('section.clFaq .popupBox').removeClass('active')
    $('body').css('overflow','')
  })
})
